// import { useEffect, useState } from 'react';
import { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

// export default function useRouterParams (props?:any) {
//   const location = useLocation();
//   const [search,setSearch] = useState({})
//   useEffect(()=>{
//     const searchParams = new URLSearchParams(location.search)
//     const allSearchParams = Object?.fromEntries(searchParams.entries());
//     console.log(' ===location',location,'==allSearchParams',allSearchParams)
//     setSearch({
//       ...location,
//       search:allSearchParams,
//     })
    
//   },[location])
  
//   return search
// }
function useRouterParams() {
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();
  // 获取查询参数对象
  const queryParams = new URLSearchParams(window.location.search);
  const allSearchParams = Object?.fromEntries(queryParams.entries());
  // const queryParams = new URLSearchParams(location.search);
  // let _url = new URL(window.location as any)
  // const allSearchParams = Object?.fromEntries(queryParams.entries());
  
  
  // 设置查询参数
  const setQueryParam = (name:string,value:string|number) => {
    queryParams.set(name, String(value));
    // const newSearch = queryParams.toString();
    // console.log('newSearch',newSearch)
    // navigate({ search: newSearch });
  };

  // const changeUrlQuery = (name:string,value:string) => {
  //   _url.searchParams.set(name,value)
  //   // navigate(_url.href)
  // }

  const changeUrlQuery = () => {
    let qs = queryParams.toString();
    let origin:any = window.location.origin;
    let pathname = window.location.pathname;
    let url = origin + pathname + "?" + qs;

    // console.log('/useRouterParams.tsx [49]--1','url',origin,url);
    (window?.history as any).replaceState({}, "", url);
    // navigate(_url.href)
  }

  const clearUrlQuery = () => {
    // let keys:any = queryParams.keys();

    // for (let key of keys) {
    //   queryParams.delete(key);
    // }
    let origin:any = window.location.origin;
    let pathname = window.location.pathname;
    let url = origin + pathname;

    (window?.history as any).replaceState({}, "", url);
    // navigate(_url.href)
  }
  
  useEffect(()=>{

  },[])
  
  return {
    setQueryParam,
    changeUrlQuery,
    clearUrlQuery,
    location,
    query:{...allSearchParams},
    params,
    navigate
  };
}

export default useRouterParams;